/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  MaterialGeneration,
  MaterialGenerationInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create material generation
 */
export const createMaterialGeneration = (
    materialGenerationInput: MaybeRefOrGetter<MaterialGenerationInput>,
 signal?: AbortSignal
) => {
      materialGenerationInput = toValue(materialGenerationInput);

      return axiosClient<MaterialGeneration>(
      {url: `/material_generations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialGenerationInput, signal
    },
      );
    }




export const getCreateMaterialGenerationMutationKey = () => ['createMaterialGeneration'] as const;

export const getCreateMaterialGenerationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMaterialGeneration>>, TError,CreateMaterialGenerationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMaterialGeneration>>, TError,CreateMaterialGenerationMutationVariables, TContext> => {

const mutationKey = getCreateMaterialGenerationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMaterialGeneration>>, CreateMaterialGenerationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMaterialGeneration(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMaterialGenerationMutationResult = NonNullable<Awaited<ReturnType<typeof createMaterialGeneration>>>
    export type CreateMaterialGenerationMutationBody = MaterialGenerationInput
    export type CreateMaterialGenerationMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateMaterialGenerationMutationVariables = {data: MaterialGenerationInput}

    /**
 * @summary Create material generation
 */
export const useCreateMaterialGeneration = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMaterialGeneration>>, TError,CreateMaterialGenerationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMaterialGeneration>>,
        TError,
        CreateMaterialGenerationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMaterialGenerationMutationOptions(options), queryClient);
    }
